import { type ComponentOptionsMixin, defineComponent } from 'vue';
import PVOrderList from 'primevue/orderlist';

export default defineComponent({
  extends: PVOrderList as unknown as ComponentOptionsMixin,
  props: {
    ...(PVOrderList as unknown as ComponentOptionsMixin).props,
  },
});
